import request from "@/utils/requestJSON";

export function getCustomizePage(JSON_NAME) {
  return request({
    url: "/storage/Customize/" + JSON_NAME + ".json",
    method: "get",
  });
}
